import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getVersion = async () => {
	const response = await api.get('/versao');
	return response.data;
};

export const useVersionList = () => {
	return useQuery(['version-list'], getVersion, {
		refetchOnWindowFocus: false,
	});
};
